module.exports = __webpack_public_path__ + "img/top3.fc5e649c.png";